import http from "../jslibs/axios/http";

// 学生列表
export const getStuList = (data) => http.get("/v1/cms/Archive", data);
// 学生详情
export const getStuListDetail = (uuid) => http.get(`/v1/cms/Archive/${uuid}`);
// 学生新增
export const addStuList = (data) => http.post("/v1/cms/Archive", data);
// 编辑
export const editStudent = (data, uuid) => http.put(`/v1/cms/Archive/${uuid}`, data);
// 删除学员
export const delStudent = (uuid) => http.delete(`/v1/cms/Archive/${uuid}`);
// 考试记录
export const examRecord = (data) => http.get("/v1/cms/UserScore", data);
// 考试记录-导出
export const exportExam = (data) => http.down("/v1/cms/UserScoreExport", data);
// 批量导入学生
export const stuImport = (data) => http.fileUp("/v1/cms/ArchiveImport", data);
